import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5","key":"svg-0"}]]

const IconLetterP = createReactComponent('outline', 'letter-p', 'LetterP', __iconNode);

export default IconLetterP;